<!-- Si hay form significa que podemos iniciar a llevarlo al formulario -->
<ng-container *ngIf="!!form" class="inner-content h-full">
  <app-address
    [addressO]="form"
    [selectedAddress]="addressSelected"
    [showClearButton]="showClearButton"
    [orderId]="orderId"
    [thereIsSelectedPoint]="thereIsPoint"
    [writeAddress]="writeAddress"
    [addressesArray]="addresses"
    [defaultAddressIndex]="defaultAddressIndex"
    [onPickUpPointSelection]="onPickUpPointSelection"
    [shippingType]="shippingType"
    [editMode]="editMode"
    [billingSameAsShipping]="billingSameAsShipping"
    class="flex justify-center"
  ></app-address>
</ng-container>
